/**
 * LoginEncouragementSection - Reusable guest-only CTA section
 * Themed to primary blue — no multi-color gradients.
 * Only renders when the user is NOT authenticated.
 */

import { Link } from 'react-router-dom';
import Button from '../ui/Button';

const BENEFITS = [
  { icon: '❤️', text: 'Like & comment on prompts you love' },
  { icon: '🔖', text: 'Save favourites to your personal library' },
  { icon: '💬', text: 'Join community chat rooms' },
  { icon: '✏️', text: 'Share your own AI prompts with the world' },
  { icon: '📸', text: 'Request any image or prompt from the community' },
  { icon: '🔔', text: 'Get notified about new trending prompts' },
];

export default function LoginEncouragementSection() {
  return (
    <section className="bg-primary-600 rounded-2xl p-8 md:p-12 text-white relative overflow-hidden">
      {/* Subtle decorative blobs using the same primary hue */}
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="absolute top-0 right-0 w-64 h-64 bg-primary-500 opacity-30 rounded-full -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-primary-700 opacity-40 rounded-full translate-y-1/3 -translate-x-1/3" />
      </div>

      <div className="relative max-w-3xl mx-auto text-center">
        <div className="text-5xl mb-4" aria-hidden="true">🚀</div>
        <h2 className="text-2xl md:text-4xl font-extrabold mb-3">
          Unlock the full PromptShare experience
        </h2>
        <p className="text-primary-100 text-lg mb-8">
          Join thousands of creators and AI enthusiasts. It's free forever.
        </p>

        {/* Benefits grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10 text-left">
          {BENEFITS.map((b) => (
            <div
              key={b.text}
              className="flex items-center gap-3 bg-primary-700 rounded-xl px-4 py-3"
            >
              <span className="text-xl" aria-hidden="true">{b.icon}</span>
              <span className="text-sm text-primary-50 font-medium">{b.text}</span>
            </div>
          ))}
        </div>

        {/* Action buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/register">
            <Button
              size="lg"
              style={{ fontSize: 13.8 }}
              className="!bg-white !text-primary-700 hover:!bg-primary-50 font-bold shadow-lg w-full sm:w-auto px-8"
            >
              Create Free Account →
            </Button>
          </Link>
          <Link to="/login">
            <Button
              variant="outline"
              size="lg"
              className="!border-white !text-white hover:!bg-primary-700 w-full sm:w-auto px-8"
            >
              Sign In
            </Button>
          </Link>
        </div>

        <p className="text-primary-200 text-xs mt-6">
          No credit card required · Join in under 30 seconds
        </p>
      </div>
    </section>
  );
}
